import { queryOptions } from "@tanstack/react-query";

import { getDataFromResponse } from "~/api/axiosUtils.ts";
import { showSellerProfile } from "~/modules/billing/sellerProfile/sellerProfileApiDispatchers.ts";

export const sellerProfileQueries = {
	baseKey: ["seller-profile"],
	details: () =>
		queryOptions({
			queryKey: [...sellerProfileQueries.baseKey, "details"],
			queryFn: () => showSellerProfile().then(getDataFromResponse),
		}),
};